
const trainerRoutes = {
    LandingPage: "/",
    Registration: "/registration",
    ResetPassword: "/reset-password/:resetId",
    VerifyEmail: '/verify-email',
    Dashboard: '/trainer/dashboard',
    trainerPreReg: '/trainer-pre-registration',
    trainerProfile: '/trainer/registration',
    trainerCourses: {
        mycourses: '/trainer/courses',  
        Trainees: '/trainer/courses/:course_id/my-trainees',
        TraineesLink: (course_id: string) => `/trainer/courses/${course_id}/my-trainees`,
        AttendanceList: '/trainer/courses/:course_id/my-attendance-list',
        AttendanceListLink: (course_id: string) => `/trainer/courses/${course_id}/my-attendance-list`,
        Result: '/trainer/courses/:course_id/results',
        ResultLink: (course_id: string) => `/trainer/courses/${course_id}/results`,
        UpdateResult: '/trainer/courses/:course_id/results/:result_id',
        UpdateResultLink: (course_id: string|undefined, result_id:string|number) => `/trainer/courses/${course_id}/results/${result_id}`,
        Quiz: '/trainer/course/:course_id/assignment/:assignment_id/quiz',
        QuizLink: (course_id: string, assignment_id :string) => `/trainer/course/${course_id}/assignment/${assignment_id}/quiz`,
        Theory: '/trainer/course/:course_id/assignment/:assignment_id/theory',
        TheoryLink: (course_id: string, assignment_id :string) => `/trainer/course/${course_id}/assignment/${assignment_id}/theory`,
        TheoryQuestions: '/trainer/course/:course_id/assignment/theory',
        TheoryQuestionsLink: (course_id: string) => `/trainer/course/${course_id}/assignment/theory`, 
        CourseInfo: `/trainer/course/:course_id/course-information`,
        CourseInformationLink: (course_id: string) => `/trainer/course/${course_id}/course-information`,
        Announcement: '/trainer/course/:course_id/announcement',
        AnnouncementLink: (course_id: string) => `/trainer/course/${course_id}/announcement`,
        NewAnnouncement: '/trainer/course/:course_id/new-announcement',
        NewAnnouncementLink: (course_id: string) => `/trainer/course/${course_id}/new-announcement`,
        Lectures: '/trainer/course/:course_id/lectures',
        LecturesLink: (course_id: string) => `/trainer/course/${course_id}/lectures`,
        Calendar: '/trainer/course/:course_id/calendar',
        CalendarLink: (course_id: string) => `/trainer/course/${course_id}/calendar`,
        Discussion: '/trainer/course/:course_id/discussions',
        DiscussionLink: (course_id: string) => `/trainer/course/${course_id}/discussions`,
        NewDiscussion: '/trainer/course/:course_id/discussion/:discussion_id/new-discussion',
        NewDiscussionGroup: '/trainer/course/:course_id/discussion/new-discussion-group',
        NewAssignment: '/trainer/course/:course_id/new-assignment',
        NewAssignmentLink: (course_id: string) => `/trainer/course/${course_id}/new-assignment`,
        Assignments: '/trainer/course/:course_id/assignments',
        AssignmentsLink: (course_id: string) => `/trainer/course/${course_id}/assignments`,
        AssignmentInfo: '/trainer/course/:course_id/assignments/info',
        AssignmentInfoLink: (course_id: string) => `/trainer/course/${course_id}/assignments/info`,
        Resources: '/trainer/course/:course_id/resources',
        ResourcesLink: (course_id: string) => `/trainer/course/${course_id}/resources`,
        EachDiscussion: '/trainer/course/:course_id/discussion/:id',
        EachDiscussionLink: (course_id: string, id: string) => `/trainer/course/${course_id}/discussion/${id}`,
        EachAnnouncement: '/trainer/course/:course_id/announcement/:id',
        EachAnnouncementLink: (course_id: string, id: string) => `/trainer/course/${course_id}/announcement/${id}`,
        UploadResources: '/trainer/course/:course_id/resources/upload',
        UploadResourcesLink: (course_id: string) => `/trainer/course/${course_id}/resources/upload`,

    }
};

export default trainerRoutes;